/// Port of mobile/lib/game/enemy.dart.

import { RectangleHitbox } from './engine/collision';
import { SpriteAnimation, SpriteAnimationComponent } from './engine/sprite';
import { anchors } from './engine/vector';
import type { EnemyData } from './enemyData';

export class Enemy extends SpriteAnimationComponent {
  readonly enemyData: EnemyData;

  /// Read every frame rather than captured, so pause and game over freeze the
  /// wing flap without the enemy holding a reference to the whole game.
  private readonly isPlaying: () => boolean;
  private readonly currentSpeed: () => number;

  constructor(data: EnemyData, isPlaying: () => boolean, currentSpeed: () => number) {
    super({
      size: { ...data.textureSize },
      anchor: anchors.bottomLeft,
      priority: 2,
    });

    this.enemyData = data;
    this.isPlaying = isPlaying;
    this.currentSpeed = currentSpeed;

    this.animation =
      data.frameCount > 1
        ? SpriteAnimation.sequenced(data.imagePath, data.frameCount, data.stepTime, data.srcSize)
        : SpriteAnimation.single(data.imagePath, data.srcSize, data.srcPosition);
  }

  override onMount(): void {
    this.add(
      RectangleHitbox.relative(0.8, this.size, {
        x: this.size.x * 0.1,
        y: this.size.y * 0.1,
      }),
    );
  }

  override update(dt: number): void {
    // Freeze wing flaps (and other frames) when not actively playing.
    if (!this.isPlaying()) return;
    super.update(dt);
  }

  /// Fixed-timestep scroll + off-screen cull.
  stepPhysics(dt: number): void {
    if (!this.isPlaying()) return;

    this.position.x -= this.currentSpeed() * dt;

    if (this.position.x < -this.size.x) {
      this.removeFromParent();
    }
  }
}
